import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import AddTaskIcon from '@mui/icons-material/AddTask';
import { styles } from '../../MilestoneModal.styles';
import { getEmptyStateStyles, getDisabledAddButtonStyles } from './EmptyState.styles';

export const EmptyState: React.FC = () => {
     return (
          <Box>
               <Typography variant="body1" sx={styles.sectionTitle}>
                    Tasks
               </Typography>
               <Box sx={getEmptyStateStyles()}>
                    <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
                         Select a milestone to view available tasks
                    </Typography>
                    <Tooltip title="Select a milestone first" arrow>
                         <span>
                              <IconButton
                                   disabled
                                   sx={getDisabledAddButtonStyles()}
                              >
                                   <AddTaskIcon />
                              </IconButton>
                         </span>
                    </Tooltip>
               </Box>
          </Box>
     );
}; 